import { createSvgIcon } from '@material-ui/core';

// Source: https://github.com/cncf/artwork/blob/main/projects/argo/icon/white/argo-icon-white.svg?short_path=f242930
export const ArgoIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 581 747">
    <path
      id="a"
      fill="#fff"
      d="M336.76 437.61c0 28.31-18.83 43.36-49.29 43.36-30.45 0-47.2-17.84-47.2-43.36 0 0 16.75 23.65 47.2 23.65 30.46 0 49.3-23.65 49.3-23.65Z"
    />
    <path
      fill="#E2F5FC"
      d="M290.5 547.98c148.47 0 268.84-120.45 268.84-269.04 0-148.58-120.37-269.03-268.84-269.03-148.47 0-268.84 120.45-268.84 269.03 0 148.59 120.37 269.04 268.84 269.04Z"
    />
    <path
      fill="#CDECF6"
      d="M290.5 504.04c121.36 0 219.74-98.45 219.74-219.9S411.86 64.24 290.5 64.24c-121.36 0-219.74 98.45-219.74 219.9s98.38 219.9 219.74 219.9Z"
    />
    <path
      fill="#fff"
      d="M208.31 91.51a12.98 12.98 0 1 0 0-25.96 12.98 12.98 0 0 0 0 25.96Zm-96.57 325.82a4.5 4.5 0 1 0 7.08-5.54c-87.8-112.21-37.15-257.65 62.5-314.74a4.5 4.5 0 0 0-4.47-7.8C73.23 148.6 20.03 300.12 111.74 417.33Z"
    />
    <path
      fill="#B5D2F3"
      d="M19.26 225.54a3.5 3.5 0 1 0-7 0h7Zm-7 105.38a3.5 3.5 0 1 0 7 0h-7Zm555.07-105.88a3.5 3.5 0 1 0-7 0h7Zm-7 105.38a3.5 3.5 0 1 0 7 0h-7ZM289.79 555.97c153.28 0 277.54-124.35 277.54-277.73h-7c0 149.52-121.13 270.73-270.54 270.73v7Zm277.54-277.73C567.33 124.84 443.07.5 289.79.5v7c149.41 0 270.54 121.21 270.54 270.74h7ZM289.79.5C136.51.5 12.26 124.85 12.26 278.24h7C19.26 128.7 140.38 7.5 289.79 7.5v-7ZM12.26 278.24c0 153.38 124.25 277.73 277.53 277.73v-7c-149.4 0-270.53-121.2-270.53-270.73h-7Zm0-52.7v105.38h7V225.54h-7Zm548.07-.5v105.38h7V225.04h-7Z"
    />
    <path
      fill="#B5D2F3"
      d="M21.66 225.73a10.84 10.84 0 1 0-21.66 0v106.43a10.84 10.84 0 1 0 21.66 0V225.73Zm559.34 0a10.84 10.84 0 1 0-21.66 0v106.43a10.84 10.84 0 1 0 21.66 0V225.73Z"
    />
    <path
      fill="#FE733E"
      d="M171.17 687.76c12.53-5.1 9.98-10.2 9.98-12.74l-6.1-92.55-5.37-46.3-8.12-289.07c0-68.6 50.73-132.72 127.3-132.72s130.76 61.71 130.88 132.77c-2.2 137.24-5.9 189.47-11.07 288.02-.63 13.47-2.38 33.86-2.96 46.32-2.88 61.66-6.14 91.87-6.14 93.53 0 2.55-2.54 7.64 9.98 12.74 12.52 5.1 41.46 11.71 41.46 13.33 0 1.6-48.89 0-48.89 0-28.02 0-28.02-20.98-28.02-26.07 0-5.1-7.64-92.6-7.64-92.6l-2.55 112.99c0 5.1 2.55 12.74 20.38 17.84 0 0 38.91 5.89 38.91 8.01 0 2.13-46.55 0-46.55 0-35.45 0-35.45-20.75-35.45-20.75l-7.64-92.6S331 700.5 331 713.24c0 9.99 1.73 17.63 29.54 22.73 13.43 3.73 40.54 8.35 40.54 10.2 0 1.85-61.86 0-61.86 0-33.11-2.55-36.24-25.5-36.24-25.5l-12.55-46.14-12.5 46.15s-5.09 22.94-38.2 25.49c0 0-56.17 1.85-56.17 0s22.5-5.99 36.81-10.2c19.36-5.69 29.55-12.74 29.55-22.73 0-12.74-2.55-105.35-2.55-105.35l-7.64 92.6s0 22.74-35.45 22.74c0 0-50.5.15-50.5-1.98 0-2.12 42.64-8 42.64-8 17.83-5.1 20.38-12.75 20.38-17.85l-2.55-113s-7.64 87.5-7.64 92.6c0 5.1 0 28.05-28.02 28.05 0 0-47.13-2.33-47.13-3.95 0-1.6 27.18-6.25 39.7-11.35Z"
    />
    <path
      fill="#FE6446"
      d="M169.68 536.16s-5.23 12.8-17.05 19.7c-11.81 6.9-25.51 9.14-38.4 10.84 0 0 17.72 8.87 39.39 6.9 13.58-1.1 19.28 2.36 21.42 8.87l-5.36-46.3Zm238.99-.99s7.63 12.8 19.45 19.7c11.82 6.9 25.51 9.15 38.4 10.85 0 0-17.72 8.87-39.38 6.9-13.58-1.1-19.29 2.35-21.43 8.87l2.96-46.32Z"
    />
    <path
      fill="#FE6446"
      d="m408.81 533 .99-16.02c-62.56 29.54-120.7 26.43-120.7 26.43s-58.49 2.45-119.92-26.57l.4 15.57s43.82 26.94 119.52 26.94c75.7 0 119.71-26.35 119.71-26.35Z"
      opacity=".3"
    />
    <path
      fill="#FEA777"
      d="M238.78 194.25a17.84 17.84 0 1 0-.01-35.67 17.84 17.84 0 0 0 .01 35.67Z"
      opacity=".5"
    />
    <path
      fill="#FE6B3C"
      d="M419.5 249.06s1.88-22.34-7.88-48.94c-26.77-73.01-92.56-87.71-128.02-85.64 0 0 50.28 23.76 52.61 99.8 1.06 33.72 1.06 34.78 1.06 34.78h82.23Z"
    />
    <path
      fill="#fff"
      d="M336.76 437.61c0 28.31-11.39 72.92-49.29 72.92s-47.2-47.4-47.2-72.92c0 0 0 43.36 47.2 43.36 51.62 0 49.3-43.36 49.3-43.36Z"
    />
    <path
      fill="#070909"
      d="M336.76 437.61c0 28.31-11.39 72.92-49.29 72.92s-47.2-47.4-47.2-72.92c0 0 0 43.36 47.2 43.36 51.62 0 49.3-43.36 49.3-43.36Z"
    />
    <path
      fill="#FE6446"
      d="M197.93 394.25a77.82 77.82 0 0 0 77.8-77.85c0-43-34.83-77.85-77.8-77.85a77.82 77.82 0 0 0-77.8 77.85c0 43 34.84 77.85 77.8 77.85Z"
    />
    <path
      fill="#fff"
      d="M197.73 378.32a60.94 60.94 0 0 0 60.92-60.96 60.94 60.94 0 0 0-60.92-60.97 60.94 60.94 0 0 0-60.92 60.97 60.94 60.94 0 0 0 60.92 60.96Z"
    />
    <path
      fill="#090B0B"
      d="M195.96 325.27a18.72 18.72 0 1 0-.01-37.44 18.72 18.72 0 0 0 .01 37.44Z"
    />
    <path
      fill="#FE6446"
      d="M381.1 394.25a77.82 77.82 0 0 0 77.79-77.85c0-43-34.83-77.85-77.8-77.85a77.82 77.82 0 0 0-77.79 77.85c0 43 34.83 77.85 77.8 77.85Z"
    />
    <path
      fill="#fff"
      d="M378 378.21a60.94 60.94 0 0 0 60.93-60.96A60.94 60.94 0 0 0 378 256.29a60.94 60.94 0 0 0-60.92 60.96A60.94 60.94 0 0 0 378 378.21Z"
    />
    <path
      fill="#090B0B"
      d="M379.13 325.27a18.72 18.72 0 1 0-.02-37.44 18.72 18.72 0 0 0 .01 37.44Z"
    />
  </svg>,
  'Argo',
);

// Source: https://images.ctfassets.net/xz1dnu24egyd/3JZABhkTjUT76LCIclV7sH/17a92be9bce78c2adcc43e23aabb7ca1/gitlab-logo-500.svg
export const GitLabIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 380 380">
    <g id="LOGO">
      <path
        fill="#e24329"
        d="M282.83,170.73l-.27-.69-26.14-68.22a6.81,6.81,0,0,0-2.69-3.24,7,7,0,0,0-8,.43,7,7,0,0,0-2.32,3.52l-17.65,54H154.29l-17.65-54A6.86,6.86,0,0,0,134.32,99a7,7,0,0,0-8-.43,6.87,6.87,0,0,0-2.69,3.24L97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82,19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91,40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
      />
      <path
        fill="#fc6d26"
        d="M282.83,170.73l-.27-.69a88.3,88.3,0,0,0-35.15,15.8L190,229.25c19.55,14.79,36.57,27.64,36.57,27.64l40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
      />
      <path
        fill="#fca326"
        d="M153.43,256.89l19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91S209.55,244,190,229.25C170.45,244,153.43,256.89,153.43,256.89Z"
      />
      <path
        fill="#fc6d26"
        d="M132.58,185.84A88.19,88.19,0,0,0,97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82s17-12.85,36.57-27.64Z"
      />
    </g>
  </svg>,
  'GitLab',
);

// Source: https://docs.puzzle.ch/_/img/sites/user_guides.svg
export const UserGuidesIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
    <circle id="bg" cx="15" cy="15" r="15" fill="#61b44b" />
    <g id="icons">
      <circle
        cx="15"
        cy="12.87"
        r="2.13"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.36 19.25a3.64 3.64 0 0 1 7.28 0h-7.29Z"
      />
      <path
        d="M23.17 10.13c.21.21.33.5.33.8V21.8c0 .94-.76 1.7-1.7 1.7H8.2c-.94 0-1.7-.76-1.7-1.7V8.2c0-.94.76-1.7 1.7-1.7h10.87c.3 0 .59.12.8.33l3.3 3.3Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M18.97 6.5v3.4c0 .63.51 1.13 1.13 1.13h3.4"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </g>
  </svg>,
  'User Guides',
);

// Source: https://docs.puzzle.ch/_/img/sites/admin_guides.svg
export const AdminGuidesIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
    <circle id="bg" cx="15" cy="15" r="15" fill="#69b978" />
    <g id="icons">
      <path
        d="M23.17 10.13c.21.21.33.5.33.8V21.8c0 .94-.76 1.7-1.7 1.7H8.2c-.94 0-1.7-.76-1.7-1.7V8.2c0-.94.76-1.7 1.7-1.7h10.87c.3 0 .59.12.8.33l3.3 3.3Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M18.97 6.5v3.4c0 .63.51 1.13 1.13 1.13h3.4M11.96 15c0 1.68 1.36 3.04 3.04 3.04s3.04-1.36 3.04-3.04-1.36-3.04-3.04-3.04-3.04 1.36-3.04 3.04Zm-1.21 0h1.21m6.08 0h1.21M15 10.75v1.21m0 6.08v1.21m-3.01-7.26.86.86m4.3 4.3.86.86m0-6.02-.86.86m-4.3 4.3-.86.86"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        d="M14.09 15c0 .5.41.91.91.91s.91-.41.91-.91-.41-.91-.91-.91-.91.41-.91.91h0Z"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </g>
  </svg>,
  'Admin Guides',
);

// Source: https://openshift.cloudscale.puzzle.ch/static/assets/public/imgs/openshift-mask-icon.svg
// God damn RedHat, why do I need a RedHat Account to download your brands icons???
export const OpenShiftIcon = createSvgIcon(
  <svg viewBox="0 0 16 16" version="1.1">
    <path
      d="m 11.5,1 h -7 C 2.5669966,1 1,2.5669967 1,4.5 v 7 C 1,13.43298 2.5669966,15 4.5,15 h 7 c 1.933003,0 3.5,-1.56702 3.5,-3.5 v -7 C 15,2.5669967 13.433003,1 11.5,1 Z M 6.4649506,4.5805117 C 7.7728928,3.9986988 9.2707214,4.2037755 10.374345,5.1159922 10.477642,5.2014421 10.492074,5.35449 10.406625,5.4581678 10.321175,5.561846 10.168126,5.5762772 10.064448,5.49045 9.1040015,4.6967195 7.800236,4.5182272 6.6624325,5.0248445 5.528425,5.5295638 4.789007,6.6145795 4.7324199,7.8560605 4.7267274,7.9863228 4.6192456,8.0881028 4.4897455,8.0881028 c -0.00341,0 -0.00721,0 -0.011016,-3.811e-4 C 4.34467,8.0816433 4.2409921,7.9680917 4.2470706,7.8340338 4.3116336,6.4076012 5.1615662,5.1608039 6.4649506,4.5805078 Z m 4.8979504,2.1764866 c 0.12191,-0.05355 0.265842,3.812e-4 0.320911,0.1234256 0.05431,0.1222861 -7.78e-4,0.2662216 -0.123426,0.3209111 l -1.065644,0.4747167 c -0.0319,0.01405 -0.0657,0.020887 -0.09874,0.020887 -0.09305,0 -0.181533,-0.05355 -0.222168,-0.1443127 -0.05431,-0.122286 7.74e-4,-0.2662215 0.123422,-0.320911 z M 5.7027438,8.745115 4.6370989,9.2198314 c -0.0319,0.014053 -0.065702,0.020886 -0.098743,0.020886 -0.093046,0 -0.1815334,-0.05355 -0.2221683,-0.1443128 C 4.2618796,8.97412 4.3169459,8.8301841 4.4396131,8.7754947 L 5.5052577,8.300778 C 5.6267858,8.246851 5.7710984,8.3011591 5.8261689,8.4242035 5.8804779,8.5464897 5.8254301,8.6904252 5.7027438,8.745115 Z m -0.4925666,1.283637 -1.0660261,0.474339 c -0.0319,0.01405 -0.065703,0.0209 -0.098743,0.0209 -0.093045,0 -0.1819104,-0.05355 -0.2221683,-0.144312 -0.054308,-0.122668 7.583e-4,-0.266223 0.1234254,-0.320913 L 5.0126917,9.5844194 c 0.1215277,-0.05355 0.2662217,3.815e-4 0.3209111,0.1234257 0.054308,0.1226672 -7.39e-4,0.2662214 -0.1234256,0.3209119 z m 4.2994236,1.390732 c -0.4929479,0.219509 -1.0128574,0.326986 -1.5285902,0.326986 -0.8522151,0 -1.6930355,-0.293946 -2.3808051,-0.862466 -0.1032966,-0.08545 -0.1177283,-0.238498 -0.032282,-0.342176 0.085447,-0.103678 0.2381168,-0.117728 0.3421756,-0.03228 0.9600695,0.79373 2.2638351,0.971841 3.4020197,0.465605 1.1374222,-0.506618 1.8772252,-1.5946744 1.9303942,-2.8399509 0.0057,-0.1340617 0.113933,-0.25445 0.252929,-0.2324234 0.134061,0.00569 0.238116,0.1188677 0.232424,0.2529294 -0.06076,1.4309905 -0.910701,2.6815869 -2.2182615,3.2637809 z M 12.053329,5.9176945 10.987305,6.3924112 c -0.0319,0.01405 -0.0657,0.020887 -0.09874,0.020887 -0.09305,0 -0.18191,-0.05355 -0.222168,-0.1443128 -0.05431,-0.1226672 7.78e-4,-0.2662218 0.123426,-0.3209111 L 11.85585,5.4733577 c 0.121528,-0.053168 0.26622,3.81e-4 0.320911,0.1234255 0.05431,0.1226672 -7.8e-4,0.2662215 -0.123428,0.320911 z"
      id="path1"
      style={{ strokeWidth: 0.388888 }}
    />
  </svg>,
  'OpenShift',
);
